import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import { useTranslation } from "react-i18next";
import { useAccountQuery } from "features/auth/authApi";
import { useSite } from "../../hooks/use-site";

const TwoFAOptInPrompt: React.FC = () => {
  const { data: account } = useAccountQuery();
  const { optionalTwofa, isSiteLoaded } = useSite();
  const navigate = useNavigate();
  const { t } = useTranslation();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (!isSiteLoaded || !optionalTwofa || !account?.user) {
      setVisible(false);
      return;
    }

    const { otp_enabled } = account.user;
    const twoFASkippedAt = window.sessionStorage.getItem("twoFASkippedAt");
    const twofaChannelId = account.user?.kycProgram?.twofa_channel_id;
    const disable2fa = account.user?.kycProgram?.disable_2fa;

    const baseEligible =
      !twoFASkippedAt &&
      otp_enabled === 0 &&
      !(twofaChannelId === 2 && disable2fa === true);

    setVisible(baseEligible);
  }, [account?.user, optionalTwofa, isSiteLoaded]);

  useEffect(() => {
    if (!visible) {
      return;
    }

    if (window.sessionStorage.getItem("twoFASkippedAt")) {
      setVisible(false);
      return;
    }

    Swal.fire({
      icon: "error",
      title: t("dashboard.twofa.title"),
      text: t("dashboard.twofa.text"),
      showCancelButton: true,
      confirmButtonText: t("dashboard.twofa.confirm"),
      cancelButtonText: t("dashboard.twofa.cancel"),
      allowOutsideClick: false,
      allowEscapeKey: false,
      allowEnterKey: false,
      reverseButtons: true,
    }).then((result) => {
      window.sessionStorage.setItem(
        "twoFASkippedAt",
        new Date().getTime().toString()
      );
      setVisible(false);
      if (result.isConfirmed) {
        navigate("/profile/");
      }
    });
  }, [visible, navigate, t]);

  return null;
};

export default TwoFAOptInPrompt;
